var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC8200",
    d: "M3.72 16.458q-.799 0-1.343-.544a1.83 1.83 0 0 1-.545-1.344V5.43q0-.8.545-1.344.544-.545 1.343-.545h12.558q.798 0 1.343.545.544.544.544 1.343v9.141q0 .799-.544 1.344-.544.544-1.343.544zM16.79 6.237l-6.293 4.016a1.3 1.3 0 0 1-.233.109.8.8 0 0 1-.265.042.8.8 0 0 1-.265-.042 1.3 1.3 0 0 1-.234-.109L3.207 6.237v8.333q0 .225.144.369a.5.5 0 0 0 .369.144h12.558q.224 0 .368-.144a.5.5 0 0 0 .144-.369zM10 9.167l6.702-4.25H3.297zM3.207 6.371V5.355v.036-.063z"
  })));
};
export default SvgEmail;